declare var BpmnJS: any;
export class BpmnElementCreator {
    private static isCreated: boolean = false;

    public create(): void {
        if (BpmnElementCreator.isCreated === true) {
            return;
        }

        customElements.define("bpmn-editor-element", BpmnElement)
        BpmnElementCreator.isCreated = true;
    }
}

export class BpmnElement extends HTMLElement {
    constructor() {
        super();
        this.create();

    }
    private shadow: ShadowRoot;


    private bpmnModeler;
    private async create() {
        this.style['color'] = 'initial'
        this.style['direction'] = 'ltr'
        this.shadow = this.attachShadow({
            mode: "closed"
        });
        

        await Promise.all([
            this.createScript("/res/bpmn/bpmn-modeler.development.js"),
            this.createLink("/res/bpmn/bpmn.css"),
            this.createLink("/res/bpmn/bpmn-js.css"),
            this.createLink("/res/bpmn/diagram-js.css"),
            this.createLink("/res/bpmn/bpmn-font/bpmn.woff"),
            this.createLink("/res/bpmn/bpmn-font/bpmn.woff2")
        ]);
        let div = document.createElement("div");
        div.id = 'canvas';
        div.style['width'] = '100%';
        div.style['height'] = '100%';
        this.shadow.appendChild(div);

        this.bpmnModeler = new BpmnJS({
            container: div,
            keyboard: {
                bindTo: window
            }
        });
        let bus = this.bpmnModeler.get("eventBus");
        bus.on('element.click', function (e) {
            this.elementChoosed(e.element);
        }.bind(this));
        bus.on('commandStack.changed', function (e) {
            this.diagramChanges();
        }.bind(this))
        await this.setXmlInternal();
    }
    public elementChoosed(element){
    
    }
    public diagramChanges(){

    }
    public async getXml():Promise<any>{
        var result = await this.bpmnModeler.saveXML({ format: true });
        return result;
    }
    stringIsNullOrEmpty(s:string):boolean{
        if(s==null)
            return true;
        else if(s.trim()=='')
            return true;
        else
            return false;
    }
    private xml:string;

    public setXml(xml:string){
        this.xml = xml;
        if(this.bpmnModeler==null)
            return;
        this.setXmlInternal();
    }

    private setXmlInternal(){
        if(this.stringIsNullOrEmpty(this.xml)==false)
            this.bpmnModeler.importXML(this.xml);
        else{
            this.bpmnModeler.createDiagram();
        }
    }
    private createScript(src: string): Promise<void> {
        let result = new Promise<void>((resolve, reject) => {
            let script = document.createElement("script");
            script.onload = () => resolve();
            script.setAttribute("src", src);
            this.shadow.appendChild(script);
        });
        return result;
    }
    private createScriptWithContent(src: string) {
        let script = document.createElement("script");
        script.innerText = src;
        this.shadow.appendChild(script);
    }
    private createLink(href: string): Promise<void> {
        let result = new Promise<void>((resolve, reject) => {
            let link = document.createElement("link");
            link.onload = () => resolve();
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("href", href);
            this.shadow.appendChild(link);
        });
        return result;
    }

    attributeChangedCallback(name, oldValue, newValue) {

    }
}